module.exports = __webpack_public_path__ + "media/newstyle/images/stars_3-red-240015a3c72f401f97729ce80cd6b163.svg";